export const LEGAL_DOCUMENT_TYPES = [
  "termsOfService",
  "termsOfUse",
  "privacyPolicy",
];

export function getLegalDocumentTypeSlug(type, i18n) {
  return i18n.t(`documents.typeSlugs.${type}`);
}

export function getLegalDocumentTypeFromSlug(slug, i18n) {
  for (const type of LEGAL_DOCUMENT_TYPES) {
    if (i18n.t(`documents.typeSlugs.${type}`) === slug) {
      return type;
    }
  }
  return null;
}
